export default class {
    constructor() {
        document.addEventListener("DOMContentLoaded", function () {
            const screenWidth = window.innerWidth;
            const maxWidth = 1024;

            if (screenWidth <= maxWidth) {
                const targetDiv = document.getElementById("primaryNavigation");

                let lastScrollTop = 0;

                const handleScroll = () => {
                    const currentScroll =
                        window.pageYOffset ||
                        document.documentElement.scrollTop;
                    if (currentScroll > lastScrollTop) {
                        // Scrolling down
                        targetDiv?.classList.add("is-hidden");
                        targetDiv?.classList.remove("is-visible");
                    } else {
                        // Scrolling up
                        targetDiv?.classList.add("is-visible");
                        targetDiv?.classList.remove("is-hidden");
                    }
                    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
                };

                window.addEventListener("scroll", handleScroll);

                // Cleanup function to remove the event listener when component unmounts
                return () => {
                    window.removeEventListener("scroll", handleScroll);
                };
            }
        });
    }
}
